import React, { ComponentType } from 'react'
import { createRoot } from 'react-dom/client'
import { RetorikWidget } from './components'

export default function renderWidget(RetorikWidget: ComponentType<any>, props: any, element: HTMLElement): void {
  const root = createRoot(element)
  root.render(<RetorikWidget {...props} />)
}

// WebComponent creation
class RetorikWidgetWebComponent extends HTMLElement {
  constructor() {
    super()
  }

  // Mehod called when the element is connected to the DOM
  connectedCallback() {
    const tenant = this.getAttribute('tenant')
    const prefix = this.getAttribute('prefix')
    const props = JSON.parse(this.getAttribute('props') || '{}')

    if (tenant) {
      const addressData = {
        tenant: tenant,
        prefix: prefix
      }

      this._renderWidget({ ...props, addressData: addressData })
    }
  }

  // React component rendering
  private _renderWidget(props: any) {
    const root = createRoot(this)
    root.render(<RetorikWidget {...props} />)
  }
}

// WebComponent registering in window
window.customElements.define('retorik-widget', RetorikWidgetWebComponent)
